module.exports = __webpack_public_path__ + "static/img/sllogo.68dd62b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sllogo.png
// module id = 1087
// module chunks = 2